import produce from "immer"
import type { Reducer } from "redux"
import type { PagingActions, PagingOptions } from "../../models/types"
import { loadPagingOptions } from "../../utils/sort-table.utils"
import { ASSET_LOAD, ASSET_LOAD_DEFAULT, ASSET_LOAD_LIST, ASSET_LOAD_PAGING_OPTIONS } from "./asset.actions"
import type { Asset, AssetActions, IAssetState } from "./asset.types"

const assetInitialState: IAssetState = {
  assets: [],
  asset: getEmptyAsset(),
  pagingOptions: {
    currentPage: 0,
    totalPages: 0,
    pageSize: 10
  }
}

export const assetReducer: Reducer<IAssetState, AssetActions | PagingActions> = (currentState, action) => {
  const state = currentState ?? assetInitialState
  switch (action.type) {
    case ASSET_LOAD_DEFAULT: {
      return loadAsset(state, getEmptyAsset())
    }
    case ASSET_LOAD_LIST: {
      return loadAssetList(state, action.payload as Asset[])
    }
    case ASSET_LOAD: {
      return loadAsset(state, action.payload as Asset)
    }
    case ASSET_LOAD_PAGING_OPTIONS: {
      return loadPagingOptions(state, action.payload as PagingOptions)
    }
    default: {
      return state
    }
  }
}

function loadAssetList(currentState: IAssetState, assets: Asset[]): IAssetState {
  return produce(currentState, (draftState: IAssetState) => {
    draftState.assets = assets
  })
}

function loadAsset(currentState: IAssetState, asset: Asset): IAssetState {
  return produce(currentState, (draftState: IAssetState) => {
    draftState.asset = asset
  })
}

function getEmptyAsset(): Asset {
  return {
    assetId: "",
    assetName: "",
    corner: { lat: 0, lng: 0 },
    oppositeCorner: { lat: 0, lng: 0 },
    projection: "",
    useProjection: true
  }
}
